import { render, staticRenderFns } from "./InviteTeachers.vue?vue&type=template&id=451fa32d&scoped=true&"
import script from "./InviteTeachers.vue?vue&type=script&lang=js&"
export * from "./InviteTeachers.vue?vue&type=script&lang=js&"
import style0 from "./InviteTeachers.vue?vue&type=style&index=0&id=451fa32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fa32d",
  null
  
)

export default component.exports